import PageContainer from "components/shared/containers/PageContainer";
import PageHeaderView from "components/shared/views/PageHeaderView";
import React from "react";
import "./styles.css";
import LoginWrapper from "components/shared/wrappers/LoginWrapper";

/**
 * @function LoginFastBalancesPage
 * @return {React.Component}
 * @exported true
 * @description The main component for LoginFastBalancesPage
 * @example
 * <LoginFastBalancesPage />
 */

export default function LoginFastBalancesPage(props) {
  return (
    <LoginWrapper>
      <PageContainer className="login-fast-balances-page">
        <PageHeaderView text="Fast Balances" />
        <FastBalanceAccountView />
      </PageContainer>
    </LoginWrapper>
  );
}

/**
 * @function FastBalanceAccountView
 * @param {STRING} accountNickname - The Account Nickname
 * @param {STRING} accountBalance - The Account Balance
 * @param {STRING} accountLastFour - The Account Number Last Four Digits
 * @param {STRING} accountType - The Account Type
 * @param {STRING} accountCurrentBalance - the Account Current Balance
 * @return {React.Component}
 * @exported false
 * @description The FastBalanceAccountView is the view for showing account balances.
 * @example
 * <FastBalanceAccountView accountNickname="Main Checking" accountBalance="$X.XX" accountLastFour="x1234" accountType="Checking" accountCurrentBalance="$X.XX" />
 */

function FastBalanceAccountView(props) {
  const accountNickname = props.accountNickname ?? "[AcctNickname]";
  const accountBalance = props.accountBalance ?? "[AcctBalance]";
  const accountLastFour = props.accountLastFour ?? "[x1234]";
  const accountType = props.accountType ?? "[Checking]";
  const accountCurrentBalance = props.accountCurrentBalance ?? "[$1234]";

  return (
    <div className="fast-balance-account-view flex-container flex-vertical align-center">
      <div className="flex-container flex-horizontal space-between align-center fast-balance-item flex-height">
        <p className="account-nickname">{accountNickname}</p>
        <p className="amount">{accountBalance}</p>
      </div>
      <div className="flex-container flex-horizontal space-between align-center fast-balance-item flex-height">
        <p className="account-information sub-text">{accountLastFour} | {accountType}</p>
        <p className="current-amount sub-text">Current {accountCurrentBalance}</p>
      </div>
    </div>
  );
}